import ViewProviderNetworksPage from "components/viewProviderNetworks/ViewProviderNetworks.component"

const ViewProviderNetworks = () => {
  return (
    <ViewProviderNetworksPage />
  )
}

export default ViewProviderNetworks
